import { Observable } from "rxjs";
import { Injectable } from "@angular/core";

import {
  HttpInterceptor,
  HttpRequest,
  HttpResponse,
} from "@angular/common/http";
import { HttpHandler } from "@angular/common/http";
import { HttpEvent } from "@angular/common/http";
import { tap } from "rxjs/operators";
import { AuthService } from "../../features/login/services/auth.service";
import { LoaderService } from "../services/loader.service";

@Injectable()
export class HttpLoaderInterceptor implements HttpInterceptor {
  constructor(
    private loaderService: LoaderService,
    private authService: AuthService
  ) {}

  intercept(
    request: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    this.loaderService.show();
    return next.handle(request).pipe(
      tap(
        (event: HttpEvent<any>) => {
          if (event instanceof HttpResponse && event.status === 401) {
            this.authService.logout();
            this.loaderService.hide();
          }

          if (event instanceof HttpResponse) {
            this.loaderService.hide();
          }
        },
        (error) => {
          this.loaderService.hide();
        }
      )
    );
  }
}
